import(/* webpackMode: "eager" */ "/private/tmp/velova-production-build-95194f1/frontend/app/error.tsx");
